import { type Translator } from '../../translations/translation-types';

export const getAuthorizeError = (t: Translator): { MESSAGE: string; TITLE: string } => {
	return {
		MESSAGE: t('pages:preAuthDetail:error:authorize:message'),
		TITLE: t('pages:preAuthDetail:error:authorize:title'),
	};
};

export const getInvalidCardError = (t: Translator): { MESSAGE: string; TITLE: string } => {
	return {
		MESSAGE: t('pages:preAuthDetail:error:invalidCard:message'),
		TITLE: t('pages:preAuthDetail:error:invalidCard:title'),
	};
};

export const getTimeoutError = (t: Translator): { MESSAGE: string; TITLE: string } => {
	return {
		MESSAGE: t('pages:preAuthDetail:error:timeout:message'),
		TITLE: t('pages:preAuthDetail:error:timeout:title'),
	};
};
